import React, { useState, useEffect } from 'react';
import { Phone, X } from 'lucide-react';

const FloatingCallButton = () => {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible || dismissed) return null;

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-[60] flex flex-col items-end gap-2" data-testid="floating-call-button">
      {expanded && (
        <div
          className="bg-white rounded-xl shadow-2xl border border-gray-100 p-3 sm:p-4 mb-1 w-56 sm:w-64 animate-in fade-in slide-in-from-bottom-2 duration-300"
          data-testid="floating-call-expanded"
        >
          <div className="flex justify-between items-start mb-2">
            <p className="text-xs sm:text-sm font-semibold text-[#101C47]">Talk to an Agent</p>
            <button
              onClick={() => { setExpanded(false); setDismissed(true); }}
              className="text-gray-400 hover:text-gray-600 -mt-1"
              data-testid="floating-call-close"
              aria-label="Close"
            >
              <X size={16} />
            </button>
          </div>
          <p className="text-[10px] sm:text-xs text-gray-500 mb-3">Get a free quote in under 5 minutes. Our local agents are ready to help.</p>
          <a
            href="tel:706-434-8184"
            className="flex items-center justify-center gap-2 bg-[#f92626] hover:bg-[#d91f1f] text-white text-xs sm:text-sm font-semibold py-2 sm:py-2.5 px-4 rounded-lg transition-colors w-full"
            data-testid="floating-call-link"
          >
            <Phone size={14} />
            706-434-8184
          </a>
          <p className="text-[10px] text-gray-400 text-center mt-2">Mon-Fri 8am-6pm EST</p>
        </div>
      )}
      <button
        onClick={() => setExpanded(!expanded)}
        className="bg-[#f92626] hover:bg-[#d91f1f] text-white rounded-full w-11 h-11 sm:w-14 sm:h-14 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 ring-4 ring-[#f92626]/20"
        data-testid="floating-call-trigger"
        aria-label="Call us"
      >
        <Phone size={20} className={`sm:w-6 sm:h-6 ${expanded ? 'rotate-12' : 'animate-pulse'}`} />
      </button>
    </div>
  );
};

export default FloatingCallButton;
